import React, {useContext, useEffect, useState} from 'react';
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import Slider from "react-slick";
import {Link, useParams} from "react-router-dom";
import {handleDateFormat, handleImageUrl, slugify} from "../helpers";
import 'react-datepicker/dist/react-datepicker.css';
import {axios} from "../axios";
import {LangContext} from "../App";
import PageIntroSection from "../components/PageIntroSection/PageIntroSection";
import Seo from "../components/Seo/Seo";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCalendar} from "@fortawesome/free-solid-svg-icons";
import {Typography} from "@mui/material";

const GuideSingle = () => {
    const id = useParams().id
    const [data,setData] = useState()
    const lang = useContext(LangContext)
    const [feed,setFeed] = useState([])
    useEffect(()=>{
        axios.get(`${lang}/guide/${id}`)
            .then(res => setData(res.data))
            .catch(() => setData(null))
    },[id,lang])
    useEffect(()=>{
        axios.get(`${lang}/guide`)
            .then(res => setFeed(res.data.tours))
            .catch(() => setFeed([]))
    },[lang])
    const [sliderSettings,setSlidersettings] = useState({
        dots: true,
        infinite: true,
        speed: 500,
        arrows:false,
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical:false,
        customPaging: (i) => <div style={{backgroundImage:`url(${i})`}}></div>,
    })
    useEffect(()=>{
        let images = data?.images?.split(',')
        if(images){
            images.pop()
            let sliderData = {...sliderSettings,customPaging:(i) => {
                    return (
                        <div style={{backgroundImage: `url(${handleImageUrl(images[i])})`}}></div>
                    )
                }}
            setSlidersettings(sliderData)
        }


    // eslint-disable-next-line react-hooks/exhaustive-deps -- loop
    },[data])
    const handleSliderImages = ()=>{
        let images = data?.images?.split(',')
        if(images){
            images?.pop()
            return images.map((img, idx) => {
                return (
                    <div key={idx} className='slider-image-wrapper'>
                        <img src={handleImageUrl(img)} alt={data?.title}/>
                    </div>
                )
            })
        }
    }
    return (
        <div className='tour-page'>
            <Seo
                pageKey="guideBook"
                title={data?.title}
                description={data?.description?.replace(/<[^>]*>?/gm, '').substring(0, 160)}
            />
            <PageIntroSection title={data?.title} text={data?.description} image={handleImageUrl(data?.thumbnail)}/>
            <div className="center-wrapper">
                <main>
                    <div className="row w-100">
                        <div className="col-9">
                            <div className="tour-info">
                                <div className="stars">
                                    <div className="star me-3">
                                        <FontAwesomeIcon icon={faCalendar}/> - {handleDateFormat(new Date(data?.created_at))}
                                    </div>
                                </div>
                            </div>
                            <div className="tour-info">
                                <div className="tour-image">
                                    <Slider {...sliderSettings}>
                                        {handleSliderImages()}
                                    </Slider>
                                </div>
                                <div className="main-text" dangerouslySetInnerHTML={{__html:data?.text}}></div>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="right-bar">
                                <Typography fontSize={30} mb={3}>{lang === 'de' ? 'Aktuelle Reiseführer' : 'Recent guides'}</Typography>
                                {feed?.filter((e) => String(e.id) !== String(id)).slice(0,4).map((e) => {
                                    const src = handleImageUrl(e.thumbnail)
                                    return (
                                        <Link key={e.id} to={`/${lang}/guide/${e.id}/${slugify(e.title || '')}`} className="card">
                                            {src && <img src={src} alt=""/>}
                                            <h3 className='title'>{e.title}</h3>
                                        </Link>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default GuideSingle;